export default {
	title: '每日体检报告',
	selectAll: '全选',
	selectedCount: '已选择 {count} 项',
	batchDelete: '批量删除',
	batchDeleteWithCount: '批量删除 ({count})',
	sendEmail: '发送邮件',
	sendEmailWithCount: '发送邮件 ({count})',
	noData: {
		title: '暂无每日体检报告',
		description: '当前没有找到相关的每日体检报告数据'
	},
	reportCard: {
		coverAlt: '每日体检报告封面',
		author: '编制人',
		approver: '审批人',
		updateTime: '更新时间'
	},
	status: {
		completed: '完成',
		editing: '编辑中'
	},
	actions: {
		upload: '上传',
		download: '下载',
		audit: '审核',
		audited: '已审核',
		delete: '删除',
		sendEmail: '发送邮件',
		batchDelete: '批量删除'
	},
	emailDialog: {
		title: '发送邮件',
		ccPerson: '抄送人',
		selectCcPerson: '请选择抄送人',
		cancel: '取消',
		confirm: '确定'
	},
	messages: {
		selectReportWarning: '请选择诊断报告',
		selectCcPersonWarning: '请选择抄送人',
		sendSuccess: '发送成功',
		deleteConfirm: '确定删除选中的 {count} 项记录吗？',
		deleteSuccess: '删除成功',
		selectDeleteWarning: '请选择删除记录',
		operateSuccess: '操作成功',
		fileUploadSuccess: '文件上传成功',
		fileUploadError: '文件上传失败',
		fileTypeError: '只能上传 PDF、Word 文档格式!',
		fileSizeError: '文件大小不能超过 10MB!',
		auditSuccess: '审核成功',
		auditWarning: '该报告已完成审核',
		auditConfirm: '确定要审核通过该报告吗？'
	},
	form: {
		fileName: '报告名称',
		startTime: '开始时间',
		endTime: '结束时间',
		title: '标题',
		filePath: '文件地址',
		fileType: '文件类型',
		startDate: '开始日期',
		endDate: '结束日期',
		attachment: '附件',
		requiredFieldCannotBeEmpty: '必填项不能为空',
		add: '新增',
		update: '修改',
		manualUpload: '人工上传',
		systemGenerate: '系统生成'
	},
	table: {
		title: '标题',
		fileName: '报告名称',
		filePath: '文件地址',
		type: '文件类型',
		startDate: '开始日期',
		endDate: '结束日期',
		updateTime: '更新时间'
	}
}
